<template>
	<div class="container">
		<h1>Achievements Admin</h1>
		<button class="btn btn-primary mb-3" @click="createAchievement">
			Create Achievement
		</button>
		<AchievementsList
			:achievements="achievements"
			@edit="editAchievement"
			@delete="deleteAchievement"
			@toggle="toggleAchievement" />
		<AchievementForm
			v-if="currentAchievement"
			:achievement="currentAchievement"
			@save="saveAchievement"
			@cancel="cancelEdit" />
	</div>
</template>

<script setup>
	import { reactive, ref, onMounted } from "vue"
	import AchievementsList from "@/components/AchievementsList.vue"
	import AchievementForm from "@/components/AchievementForm.vue"
	import Swal from "sweetalert2"
	import { useTokenStore } from "@/stores/token"
	// import { hasTokenIssue, handleTokenIssue } from "@/utils/tokenIssue"
	import { fetchWithAuth } from "@/utils/api-client"

	const tokenStore = useTokenStore()

	const achievements = reactive([])

	const currentAchievement = ref(null)

	const fetchAchievements = async () => {
		const response = await fetchWithAuth("/api/achievements", {
			// headers: {
			// 	Authorization: `Bearer ${tokenStore.token}`,
			// },
		})
		// if (hasTokenIssue(response)) {
		// 	handleTokenIssue(response)
		// } else {
		const data = await response.json()
		achievements.splice(0, achievements.length, ...data)
		// }
	}

	onMounted(fetchAchievements)

	const createAchievement = () => {
		currentAchievement.value = {
			name: "",
			description: "",
			criteria: [],
			aggregate: null,
			imageUrl: "",
			enabled: true,
			validFrom: "",
			validTo: "",
		}
	}

	const editAchievement = (achievement) => {
		currentAchievement.value = { ...achievement }
	}

	const deleteAchievement = async (id) => {
		const result = await Swal.fire({
			title: "Are you sure?",
			text: "You won't be able to revert this!",
			icon: "warning",
			showCancelButton: true,
			confirmButtonColor: "#3085d6",
			cancelButtonColor: "#d33",
			confirmButtonText: "Yes, delete it!",
		})

		if (result.isConfirmed) {
			const response = await fetchWithAuth(`/api/achievements/${id}`, {
				method: "DELETE",
				// headers: {
				// 	Authorization: `Bearer ${tokenStore.token}`,
				// },
			})
			// if (hasTokenIssue(response)) {
			// 	handleTokenIssue(response)
			// } else {
			const index = achievements.findIndex((a) => a._id === id)
			if (index !== -1) {
				achievements.splice(index, 1)
				Swal.fire("Deleted!", "The achievement has been deleted.", "success")
			}
			// }
		}
	}

	const toggleAchievement = async (id) => {
		const achievement = achievements.find((a) => a._id === id)
		if (achievement) {
			achievement.enabled = !achievement.enabled
			const response = await fetchWithAuth(`/api/achievements/${id}`, {
				method: "PUT",
				headers: {
					"Content-Type": "application/json",
					// Authorization: `Bearer ${tokenStore.token}`,
				},
				body: JSON.stringify({ enabled: achievement.enabled }),
			})
			// if (hasTokenIssue(response)) {
			// 	handleTokenIssue(response)
			// } else {
			Swal.fire(
				"Updated!",
				`The achievement has been ${
					achievement.enabled ? "enabled" : "disabled"
				}.`,
				"success"
			)
			// }
		}
	}

	const saveAchievement = async (achievement) => {
		try {
			if (achievement._id) {
				const response = await fetchWithAuth(
					`/api/achievements/${achievement._id}`,
					{
						method: "PUT",
						headers: {
							"Content-Type": "application/json",
							// Authorization: `Bearer ${tokenStore.token}`,
						},
						body: JSON.stringify(achievement),
					}
				)
				// if (hasTokenIssue(response)) {
				// 	handleTokenIssue(response)
				// } else {
				const index = achievements.findIndex((a) => a._id === achievement._id)
				if (index !== -1) {
					achievements[index] = { ...achievement }
				}
				Swal.fire("Success!", "Achievement updated successfully.", "success")
				// }
			} else {
				const response = await fetchWithAuth("/api/achievements", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						// Authorization: `Bearer ${tokenStore.token}`,
					},
					body: JSON.stringify(achievement),
				})
				// if (hasTokenIssue(response)) {
				// 	handleTokenIssue(response)
				// } else {
				const newAchievement = await response.json()
				achievements.push(newAchievement)
				Swal.fire("Success!", "Achievement created successfully.", "success")
				// }
			}
			cancelEdit()
		} catch (error) {
			Swal.fire("Error!", "Something went wrong.", "error")
		}
	}

	const cancelEdit = () => {
		currentAchievement.value = null
	}
</script>

<style>
	.container {
		margin-top: 20px;
	}
</style>
